import { FC, useCallback, useMemo, useState } from 'react'
import styles from 'components/features/rewards/rewardPage/SummaryChart/SummaryChart.styl'
import { ChartLineArea } from 'components/atoms/chart/ChartLineArea/ChartLineArea'
import { generate } from 'randomstring'
import { ChartHighlight } from 'components/atoms/chart/ChartHighlight/ChartHighlight'
import { CryptoChart } from 'components/features/rewards/rewardPage/store'
import { useCryptoChartContext } from 'components/features/rewards/rewardPage/useCryptoChartContext'
import { CryptoChartPreset } from 'components/features/rewards/rewardPage/CryptoChartPreset/CryptoChartPreset'

const usdColor = '#95cd85'
const cryptoColor = '#66c8ec'

type SummaryChartProps = {
  data: CryptoChart
  onHover: (index: number) => void
}
export const SummaryChart: FC<SummaryChartProps> = (props) => {
  const { data, onHover } = props

  const cashGradId = useMemo(generate, [])
  const cryptoGradId = useMemo(generate, [])
  const gradChild = useMemo(() => (
    <>
      <linearGradient id={ cashGradId } x1='0' y1='0' x2='0' y2='1' spreadMethod='pad'>
        <stop offset='0%' stopColor={ usdColor } />
        <stop offset='100%' stopColor={ usdColor } />
      </linearGradient>
      <linearGradient id={ cryptoGradId } x1='0' y1='0' x2='0' y2='1' spreadMethod='pad'>
        <stop offset='0%' stopColor={ cryptoColor } />
        <stop offset='100%' stopColor={ cryptoColor } />
      </linearGradient>
    </>
  ), [cashGradId, cryptoGradId])

  const [hoverIndex, setHoverIndex] = useState(-1)
  const handleHover = useCallback((index: number) => {
    setHoverIndex(index)
    onHover(index)
  }, [onHover])

  const [size, setSize] = useState({ width: 0, height: 0 })
  const chartContexts = useCryptoChartContext(data, size)
  const { chartContext, usdLineContext, cryptoLineContext } = chartContexts


  const areaChild = useMemo(() => {
    return (
      <>
        <ChartLineArea
          context={ cryptoLineContext }
          className={ styles.cryptoArea }
          style={{
            fill: `url(#${ cryptoGradId })`,
          }}
        />
        <ChartLineArea
          context={ usdLineContext }
          className={ styles.cashArea }
          style={{
            fill: `url(#${ cashGradId })`,
          }}
        />

      </>
    )
  }, [cashGradId, cryptoLineContext, usdLineContext, cryptoGradId])

  return (
    <CryptoChartPreset
      contexts={ chartContexts }
      onHover={ handleHover }
      onSize={ setSize }
    >
      <defs>
        { gradChild }
      </defs>

      { areaChild }
      { hoverIndex !== -1 && (
        <ChartHighlight context={ chartContext } index={ hoverIndex } height={ size.height } />
      )}

    </CryptoChartPreset>
  )
}
